import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import amfori from "img/amfori.svg"
import hero2 from "img/bg-3-d.webp"
import { Link } from "react-router-dom"

const Single = () => {
  return (
    <Box
      className="height-100"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.4)), 
          url(${hero2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        position: "relative",
        "& img": {
          display: "block",
          position: "absolute",
          top: 20,
          left: 0,
          height: "auto",
          width: "50%",
          p: 2,
        },
      }}
    >
      <Box sx={{ width: { xs: "90%", md: "70%" } }}>
        {/* <Typography
          sx={{ color: "#ffffff" }}
          variant="h5"
          fontWeight="bold"
          gutterBottom
        >
          Fully Export Oriented
        </Typography> */}
        <Typography
          sx={{ color: "white" }}
          variant="h4"
          fontWeight="bold"
          gutterBottom
        >
          Design meets <br /> perfection
        </Typography>
        <Button
          component={Link}
          to="/category"
          sx={{ px: 2, color: "#fff" }}
          variant="contained"
          color="secondary"
          size="small"
        >
          Products
        </Button>
      </Box>
      <img src={amfori} alt="amfori" />
    </Box>
  )
}

export default Single
